
import React, { Component } from 'react';
import { FormattedMessage } from '@jutro/locale';
import { InlineNotification } from '@jutro/components';

import messages from './MLAccountBillingConfirmation.messages';
import styles from './MLAccountBillingConfirmation.module.scss';

import { Button } from '@jutro/legacy/components';

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

class MLAccountBillingConfirmation extends Component {
    static contextType = TranslatorContext;

    formatAmountString = (amount) => {
        const premium = _.get(amount, 'amount', 0);
        const currency = _.get(amount, 'currency', 'usd');
        const { intl } = this.props;
        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    };

    formatDateString = (date) => {
        const { intl } = this.props;
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    };

    render() {
        const translator = this.context;
        const {
            confirmation,
            agencySweepIndicator,
            selectedPaymentInstrument
        } = this.props.history.location.state;

        const printConfirmation = () => {
            window.print();
        };

        const getAccountName = () => {
            const nick = confirmation?.nickname ? confirmation.nickname : (selectedPaymentInstrument?.value?.nickname ? selectedPaymentInstrument?.value.nickname : selectedPaymentInstrument?.value?.accountType_ML);
            return translator(messages.paymentMethodXEndingInX,
                {
                    nickname: nick,
                    last4Digits: confirmation?.last4Digits ? confirmation.last4Digits : selectedPaymentInstrument?.value.last4Digits
                });
        };

        const successfulConfirmations = confirmation.confirmations.filter((payment) => !payment.reversed);
        const failedPayments = confirmation.confirmations.filter((payment) => payment.reversed);

        return (
            <>
                <InlineNotification
                    id="successNotification"
                    type="success"
                    isDismissable={false}
                    message={<strong>{translator(messages.paymentProessed)}</strong>}
                    className="ml-alert ml-alert-success ml-section vertical-spacing-40"
                    messageProps={{
                        success: ' '
                    }}
                />
                {failedPayments.map((payment) =>
                    <InlineNotification
                        id="failNotification"
                        type="error"
                        isDismissable={false}
                        message={<strong>{translator(messages.paymentFail, {amount: this.formatAmountString(payment.paidAmount), policyNumber: payment.policyNumber})}</strong>}
                        className="ml-alert ml-alert-error ml-section vertical-spacing-40"
                        messageProps={{
                            error: ' '
                        }}
                    />
                )}
                <section className="ml-section clearfix">
                    <header><div className={styles.confirmation}>{translator(messages.confirmation)}</div></header>
                    <h2 className={styles.paymentMessage}>{translator(messages.thankYou)}</h2>
                    <div className={styles.confirmationItem}>
                        <Button onClick={printConfirmation}>
                            {translator(messages.printConfirmation)}
                        </Button>
                    </div>
                    {successfulConfirmations.map((confirmationItem) =>
                        <div className={styles.confirmationItem}>
                            <div>{translator(messages.paymentConfirmaionNumber, { confirmationNumber: confirmationItem.confirmationNumber })}</div>
                            <div>{translator(messages.policyNumber, { policyNumber: confirmationItem.policyNumber })}</div>
                            <div>{translator(messages.paymentAmount, { amount: this.formatAmountString(confirmationItem.paidAmount) })}</div>
                        </div>
                    )}
                    <div className={styles.confirmationItem}>
                        <div>{translator(messages.paymentDate, { date: this.formatDateString(confirmation.effectiveDate) })}</div>
                        {agencySweepIndicator === true &&
                            <div>{translator(messages.paymentMethod, { method: 'Agency Sweep Account', last4Digits: confirmation.last4Digits })}</div>
                        }
                        {agencySweepIndicator !== true &&
                            <div className={styles.paymentMethodName}>{getAccountName()}</div>
                        }
                    </div>
                    {confirmation.methodDiff &&
                        <div className={styles.confirmationItem}>
                            <FormattedMessage
                                {...messages.reminderMessage}
                                values={{
                                    reminder: (
                                        <strong>{translator(messages.reminder)}</strong>
                                    )
                                }}
                            />
                        </div>
                    }
                </section>
            </>
        )
    }
}

export const AccountBillingConfirmation = MLAccountBillingConfirmation;
export default withIntl(MLAccountBillingConfirmation);